
<template>
    <vue3-html2pdf :show-layout="false" :float-layout="true" :enable-download="true" :preview-modal="false"
        :paginate-elements-by-height="calcBreakHeight" :filename="PDFName" :enableLinks="true" :pdf-quality="2"
        :manual-pagination="true" pdf-format="a4" pdf-orientation="portrait" pdf-content-width="800px"
        @progress="onProgress($event)" @hasStartedGeneration="hasStartedGeneration()" @hasGenerated="hasGenerated($event)"
        ref="html2Pdf">

        <template v-slot:pdf-content>

            <!-- header -->
            <div class="pdf__header" :style="{ 'background-color': color }">
                <div class="pdf__title">{{ headerTitle }}</div>
            </div>

            <!-- content created in child -->
            <slot></slot>

            <!-- content example -->

        <!--    
                <h3 class="pdf__element pdf__subtitle">{{ properties.resultTitle }}</h3>

                <article class="pdf__element pdf__listitem" v-for="accordion in sortedResponses" :key="accordion.title">
                    
                        <div class="pdf__listitem__title">
                            <span>{{ accordion.score }} points</span>
                            {{ accordion.title }}
                        </div>
                        
                        <div class="pdf__listitem__text" v-html="accordion.text" ></div>
                        
                </article> 
                            -->

        </template>

    </vue3-html2pdf>

    <a class="hyperLink" @click="generateReport">
        <div>
            <img src="@/assets/img/ui/btn-arrow.svg" />
        </div>
        {{ buttonText }}
    </a>
</template>

<script>
import Vue3Html2pdf from 'vue3-html2pdf'
export default {
    name: "PDFGen",
    props: ["headerTitle", "buttonText", "PDFName", "color"],
    methods: {
        generateReport() {
            _paq.push(["trackEvent", "pdf", "download", window.app.vm.$route.path]);
            this.$refs.html2Pdf.generatePdf()
        },

        onProgress() {
            console.log("pdf creating..")
        },
    },
    components: {
        Vue3Html2pdf
    },
    data() {

        return {
            windowWidth: window.innerWidth
        }
    },
    mounted() {
        window.onresize = () => {
            this.windowWidth = window.innerWidth
        }
    },

    computed: {
        calcBreakHeight() {

            var breakHeight = 1200;
            if (this.windowWidth < 768) {
                breakHeight = 1200
            }
            return breakHeight;
        }
    }

}


</script>

<style lang="scss">
@import '@/assets/sass/_responsiveness.scss';

// pdf standard elements
.pdf {



    &__header {
        padding: 0px;
        height: 200px;
        color: #fff;
        background-image: url(@/assets/img/ui/logo.png);
        background-repeat: no-repeat;
        background-position: 30px 30px;
        position: relative;
    }

    &__title {
        position: absolute;
        right: 40px;
        bottom: 30px;
        font-size: 38px;
        font-weight: 700;
        max-width: 60%;
        text-align: right;
    }

    &__element {
        padding: 60px 100px 0;
        margin-bottom: -20px;

        p {
            margin: 1em 0 !important;

            //font-size: 14px;
            &.double-space {
                margin: 2em 0 1em;
            }


        }

        @include x-small-mobile-only {
            p {
                font-size: 0.4em;
            }
        }

        &:last-of-type {
            margin-bottom: -10px;
        }
    }

    &__subtitle {
        font-size: 25px;
        font-weight: bold;
    }

}

//  pdf version of accordion content
.pdf__listitem {

    &__title {
        position: relative;
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: bold;
        padding: 20px 0 10px;

        &>span {
            flex: none;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 12px;
            border: solid 2px #000;
            background: #fff;
            margin-right: 12px;
            padding: 10px;
        }
    }

}


// pdf version of thumbs up/down column content
.pdf__updowncol {
    padding-top: 120px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    text-align: left;

    &>div {
        position: relative;
        width: 48%;
        border-top: solid 4px;
        padding-top: 16px;
        padding-bottom: 40px;

        &::after {
            content: '';
            position: absolute;
            left: 0;
            bottom: calc(100% + 16px);
            width: 32px;
            height: 32px;
            background-position: center;
            background-size: 100%;
            background-repeat: no-repeat;
        }

        &:first-of-type {
            font-weight: bold;

            &::after {
                background-image: url(@/assets/img/ui/question-circle-pdf.svg);
            }
        }

        &:last-of-type {
            border-color: #000;

            &::after {
                background-image: url(@/assets/img/ui/thumb.svg);
            }
        }
    }

    &.QuizThumbsUpDownResponse__results_result--thumbsdown {
        &>div {
            &:last-of-type {
                &::after {
                    transform: scaleY(-1);
                }
            }
        }
    }
}</style>